export const GET_BUSINESS_TYPES_OPENINGS = 'GET_BUSINESS_TYPES_OPENINGS';
export const UNATORIZED = 'UNATORIZED';
export const ERROR_BUSINESS_TYPES_OPENINGS = 'ERROR_BUSINESS_TYPES_OPENINGS';
